import { render, staticRenderFns } from "./Courses-list-admin-tab.vue?vue&type=template&id=0b266c76"
import script from "./Courses-list-admin-tab.vue?vue&type=script&lang=js"
export * from "./Courses-list-admin-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports